
import XButton from 'vux/src/components/x-button/index.vue'

import {clearLogined, removeSStore,removeLStore, getSStore, IsValid } from "@js/public/mUtils";
import Dialog from "@/components/publicComponents/dialog";
export default {
components: {
XButton,
"my-dialog": Dialog
},

props: {
mes: {
type: Object,
default: {}
},
openResult: {
type: Object,
default: {}
},
openFlag: {
type: Boolean,
default: true,
}
},

data() {
return {
imgurl: "@/../static/images/success-h.png",
from: {
title: "",
buttons: []
}
};
},
created() {
this.loaded();

},
watch: {
data: function(val, oldVal) {
console.log(val);
}
},
methods: {
clickBtn(link, text) {
console.log(link,text,990);
if (IsValid(link)) {
if (link === "-2") {
this.close();
} else if (link === "-1") {
this.toBack();
} else if (link === "0") {
this.$emit("callback");
} else if (link === "comeIn/home") {
this.eventBus.$emit("changeMenu", 0);
this.toPage(link, {});
} else if (link === "comeIn/money/all") {
this.eventBus.$emit("changeMenu", 1);
this.toPage(link, {});
} else if (link === "train") {
this.eventBus.$emit("changeMenu", 2);
this.toPage(link, {});
} else if (link === "comeIn/personalCenter") {
this.eventBus.$emit("changeMenu", 3);
this.toPage(link, {});
} else if (link === "/changeBag") {
this.$emit("upBag");

} else if (link === "/login") {
if(text && text == '退出登录') {
clearLogined();
sessionStorage.clear()
removeSStore('buyData');
removeSStore('xhcWl');
removeSStore('isOpenLqbNumber');
removeLStore('pdfArr')
this.$vux.toast.show({
type: "text",
text: "注销成功"
});
}
this.toPage(link, {});
this.$router.go(0);
} else {


if (link === '/registerTwo?action=register&source=wx') {
this.sa.track('open_account_page_view', {
source_page: '基金'
})
}
this.toPage(link, {});
}
}
},
close() {
this.$emit('closepop');
}
}
};



// WEBPACK FOOTER //
// ./src/components/publicComponents/resultDialog.vue